//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from '@/components/NavBar';
import CommonFooter from '@/components/CommonFooter';
import TitleBox from '@/components/TitleBox';
import ScrollTop from '@/components/ScrollTop.vue';

export default {
    components: { NavBar, CommonFooter, TitleBox, ScrollTop },
    beforeRouteEnter(to, from, next) {
        const obj = {
            wharfCulture: 0,
            redCulture: 1,
            folkCulture: 2
        };
        const params = to.params;
        next((vm) => {
            vm.currentItem = obj[params.anchor] || 0;
        });
    },
    beforeRouteUpdate(to, from) {
        const obj = {
            wharfCulture: 0,
            redCulture: 1,
            folkCulture: 2
        };
        this.currentItem = obj[to.query.anchor];
    },
    data() {
        return {
            currentItem: 0,
            typeList: [],
            red: '',
            wharf: '',
            custom: '',
            banner: ''
        };
    },
    mounted() {
        this.getTypes();
        this.getWharf();
        this.getRed();
        this.getCustom();
    },
    methods: {
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 6
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.typeList = res.data;
                }
            });
        },
        getRed() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '43'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.red = res.data.content;
                }
            });
        },
        getCustom() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '44'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.custom = res.data.content;
                }
            });
        },
        getWharf() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '42'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.wharf = res.data.content;
                }
            });
        }
    }
};
